import DynamicFormContactModelBase from '../_generated/modelBases/dynamic-form-contact-model-base';

export default class DynamicFormContactModel extends DynamicFormContactModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
